export default __webpack_public_path__ + "static/media/video-settings.0ba844df.svg";